import { Avatar } from '../../../layout/Avatar.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { formatIQD, formatDateTime } from '../../../shared/format.js';

const POS_TYPE_LABELS = {
  cafeteria: 'الكافتيريا',
  toys: 'الألعاب',
  checkout: 'المحاسبة',
  play_fee: 'رسوم اللعب',
  manual: 'يدوي'
};

// ‏/pos/sales يعيد مستندات الفاتورة كما هي: `grandTotal` لا `totalAmount`،
// و`childId` كائناً مُعبّأً لا `childName`. قراءة المفاتيح القديمة كانت
// تعرض «—» و«0 د.ع» في كل سطر.
function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.rows || data?.data || data?.items || [];
  return arr.slice(0, 8).map((r, i) => {
    const child = r.childId && typeof r.childId === 'object' ? r.childId : null;
    const guardian = r.guardianId && typeof r.guardianId === 'object' ? r.guardianId : null;
    const posType = r.posType ?? r.type ?? r.category ?? '';
    return {
      id: r.id ?? r._id ?? `inv-${i}`,
      childName: r.childName
        ?? child?.name
        ?? r.customerName
        ?? guardian?.name
        ?? (r.cardUid ? `كارت ${r.cardUid}` : 'زبون نقدي'),
      childId: child?._id ?? child?.id ?? r.childId ?? r.id ?? `c${i}`,
      type: POS_TYPE_LABELS[posType] || posType || '—',
      typeKey: posType,
      amount: Number(r.grandTotal ?? r.totalAmount ?? r.amount ?? r.total ?? 0),
      status: r.paymentStatus ?? r.status ?? 'paid',
      createdAt: r.createdAt ?? r.time ?? r.date
    };
  });
}

const TYPE_TONE = {
  cafeteria: 'orange',
  toys: 'info',
  play_fee: 'success',
  checkout: 'success'
};

export function LatestInvoicesTable({ data }) {
  const rows = normalize(data);

  if (!rows.length) {
    return (
      <div className="px-4 py-10 text-center text-ink-3 text-sm">لا توجد فواتير حتى الآن</div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead>
          <tr className="text-ink-3 text-[11.5px] uppercase tracking-wider">
            <th className="text-right font-semibold py-2 px-3">الوقت</th>
            <th className="text-right font-semibold py-2 px-3">الطفل</th>
            <th className="text-right font-semibold py-2 px-3">القسم</th>
            <th className="text-right font-semibold py-2 px-3">المبلغ</th>
            <th className="text-right font-semibold py-2 px-3">الحالة</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const isPaid = r.status === 'paid' || r.status === 'completed';
            const isCancelled = r.status === 'cancelled';
            return (
              <tr key={r.id} className="border-t border-line">
                <td className="py-2 px-3 text-ink-3 text-[11.5px] font-mono">
                  {r.createdAt ? formatDateTime(r.createdAt) : '—'}
                </td>
                <td className="py-2 px-3">
                  <div className="flex items-center gap-2">
                    <Avatar size="sm" name={r.childName} id={r.childId} />
                    <span className="font-semibold">{r.childName}</span>
                  </div>
                </td>
                <td className="py-2 px-3">
                  <Pill variant={TYPE_TONE[r.typeKey] || 'muted'}>{r.type}</Pill>
                </td>
                <td className="py-2 px-3 font-bold">{formatIQD(r.amount)}</td>
                <td className="py-2 px-3">
                  {isCancelled ? (
                    <Pill variant="danger">ملغاة</Pill>
                  ) : isPaid ? (
                    <Pill variant="success">مدفوعة</Pill>
                  ) : (
                    <Pill variant="orange">معلقة</Pill>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
